import axios from 'axios';
import { Form, Formik } from 'formik';
import React, { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FaExclamationCircle } from 'react-icons/all';
import { useDispatch, useSelector } from 'react-redux';
import * as yup from 'yup';
import { closeAllModals } from '../../../actions/modalActions';
import { CHAT_BOT_AUTHENTICATION } from '../../../constants/paths/api';
import { getCurrentLangPretty } from '../../../helpers/url/urlHelpers';
import { ReactComponent as Close } from '../../../icons/close-button.svg';
import Button from '../../base/button/index';
import FormikFieldWrapper from '../../base/forms/formikFieldWrapper';
import { StyledFormikField } from '../../base/forms/input';
import { A } from '../../base/typography/anchors';
import { P } from '../../base/typography/typography';
import * as StyledModals from '../../myPost/modals/myShipmentsModals.styles';

interface Props {}

const ChatAuthenticationModal: FC<Props> = () => {
	const { t } = useTranslation('generalForm');
	const dispatch = useDispatch<any>();
	const { modalHeading } = useSelector(({ modalReducer }) => modalReducer);
	const [loading, setLoading] = useState(false);
	const [errorMessage, setErrorMessage] = useState('');

	const closeModal = () => {
		setErrorMessage('');
		dispatch(closeAllModals());
		document.body.style.overflow = 'unset';
	};
	document.body.style.overflow = 'hidden';

	const initialValues = {
		phone: '',
	};
	const validationSchema = yup.object().shape({
		phone: yup
			.string()
			.required('required')
			// TODO
			.min(7, 'must-be-7')
			.max(7, 'must-be-7')
			.matches(/^[0-9]*$/, 'only-numbers'),
	});

	const authenticate = (phonenumber, username) => {
		setLoading(true);
		setErrorMessage('');

		const url =
			CHAT_BOT_AUTHENTICATION +
			'?phonenumber=' +
			phonenumber +
			'&username=' +
			username +
			'&prompt=' +
			(getCurrentLangPretty() === 'is' ? 'Innskráning í vefspjall Póstsins' : 'Iceland post chat verification');

		axios
			.post(url, '', { headers: { lang: getCurrentLangPretty() } })
			.then(() => {
				setLoading(false);
				// @ts-ignore
				window.zChat.sendChatMsg('Auðkenning tókst');
				closeModal();
			})
			.catch(error => {
				// @ts-ignore
				window.zChat.sendChatMsg(`Auðkenning mistókst (${error.message})`);
				setLoading(false);
				setErrorMessage(error.response.data.message);
			});
	};

	return (
		<StyledModals.Wrapper>
			<StyledModals.Heading>
				<div>{t('chatAuth')}</div>
				<A onClick={closeModal}>
					<Close />
				</A>
			</StyledModals.Heading>
			<P>{t('chatAuthInfo')}</P>
			{errorMessage.length > 0 && (
				<StyledModals.ErrorMessage>
					<FaExclamationCircle />
					<div>{errorMessage}</div>
				</StyledModals.ErrorMessage>
			)}
			<Formik
				initialValues={initialValues}
				validationSchema={validationSchema}
				onSubmit={values => {
					authenticate(values.phone, modalHeading);
				}}>
				<Form>
					<FormikFieldWrapper label={t('phone')} name="phone" languageComponent="myShipments" smallLabel>
						<StyledFormikField type="text" id="phone" name="phone" placeholder={t('phone')} />
					</FormikFieldWrapper>

					<Button primary type="submit" isLoading={loading}>
						{t('submit')}
					</Button>
				</Form>
			</Formik>
		</StyledModals.Wrapper>
	);
};

export default ChatAuthenticationModal;
